/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import ContentCard from '../../../../../components/ui-elements/cards/ContentCard';
import { BsFillPeopleFill, BsLockFill } from 'react-icons/bs';
const ManageOrgApplicationsUsersPage = () => {
 
    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Organizations Applications Users'} />
                    </Grid>
                    
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/manage-organizations-applications-users/general" title="General" icon={<BsFillPeopleFill />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/manage-organizations-applications-users/permissions" title="Permissions" icon={<BsLockFill />}></ContentCard>
                    </Grid>
             
                </Grid>
            </Box>

        </>
    )

}


export default ManageOrgApplicationsUsersPage; 